import styled from '@emotion/styled';
import { StyledButton } from '@selfserve/react-ui';
import { AnswerData } from '../data';

const StyledRadioButton = styled(
  StyledButton,
  {}
)(({ theme, odd }: { theme?: any; odd?: boolean }) => ({
  fontSize: '14px',
  marginRight: '0',
  marginBottom: '16px',
  fontWeight: '500',
  borderColor: theme.palette.grey['400'],
  padding: '11px 8px 11px 8px',
  flexBasis: 'calc(50% - 8px)',
  height: '40px',
  fontFamily: 'Lato',
  [theme.breakpoints.down('md')]: {
    flexBasis: '100%',
  },

  '&.selected': {
    borderColor: '#006EFA',
    backgroundColor: 'rgba(0, 110, 250, 0.05)',
  },

  ...(odd && {
    '&:last-child': {
      flexBasis: '100%',
    },
  }),
}));

interface Props {
  handleAnswerSelected: any;
  answer: AnswerData;
  odd?: boolean;
}

export const MarketingInfoRadio = ({
  handleAnswerSelected,
  answer,
  odd,
}: Props) => {
  const { selected, answerName, text } = answer;

  return (
    <StyledRadioButton
      id={answerName}
      name="email"
      fullWidth
      isBorderless
      onClick={handleAnswerSelected}
      className={selected ? 'selected' : ''}
      odd={odd}
      key={answerName}
    >
      {text}
    </StyledRadioButton>
  );
};
